import {submitInterviewExperience} from 'iq-interview_experiences/api';
import type {InterviewExperienceSubmitData} from 'iq-interview_experiences/types';
import type {PostAuthAction} from 'iq-auth/post_auth_actions';
import {toast} from '@repo/ui/toaster';

/**
 * Submits an interview experience the user composed before authenticating. Runs
 * for any authenticated user (login or signup). Surfaces its own error toast so
 * it works from the OAuth callback where the original submission UI is gone.
 */
export const submitInterviewExperienceAction: PostAuthAction<InterviewExperienceSubmitData> = {
  key: 'iq:pending-experience',
  run: async (payload) => {
    try {
      await submitInterviewExperience(payload);
    } catch {
      toast.error('Failed to submit your experience. Please try again.');
    }
  },
};
